import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import CallToAction from './CallToAction';

// Styles
import './Hero.scss';

const HeroTitleWrapper = props => (
  <div className="hero__content-box">{props.children}</div>
);

const HeroTitle = ({ children, colorTitle = '' }) => {
  const heroSubtitleClassname = classNames([
    'hero__title',
    `hero__title--${colorTitle}`
  ]);
  return <h2 className={heroSubtitleClassname}>{children}</h2>;
};

const HeroSubTitle = ({ children, colorSubtitle = '' }) => {
  const heroSubtitleClassname = classNames([
    'hero__subtitle',
    `hero__subtitle--${colorSubtitle}`
  ]);
  return <h2 className={heroSubtitleClassname}>{children}</h2>;
};

const Hero = ({
  title,
  subtitle = null,
  backgroundImage = null,
  size = 'default',
  opacity = false,
  callToActionText = '',
  callToActionPath = '',
  className = '',
  classNameImage = '',
  isRowAlignContent = false,
  image = null,
  colorTitle = '',
  colorSubtitle = '',
  menu = null,
  dataTest = '',
  children
}) => {
  const inlineStyle = {
    backgroundImage
  };

  const heroClassname = classNames(
    'hero',
    {
      'hero--opacity': opacity
    },
    [`hero--${size}`],
    className
  );

  const renderContentBox = () => {
    if (isRowAlignContent) {
      return (
        <div className="hero__content-box--rowAlign">
          <div className="hero__content-box--row">
            <HeroTitle colorTitle={colorTitle}>{title}</HeroTitle>
            {subtitle && (
              <HeroSubTitle colorSubtitle={colorSubtitle}>
                {subtitle}
              </HeroSubTitle>
            )}
            {callToActionText ? (
              <p className="hero__call-to-action">
                <CallToAction
                  href={callToActionPath}
                  text={trans(callToActionText)}
                  dataTest={dataTest}
                />
              </p>
            ) : null}
          </div>
          {typeof image === 'string' ? (
            <img
              alt={trans('landingpage.city_selector.trustpilot.logo.alt')}
              className={`hero__content--image ${classNameImage}`}
              src={image}
            />
          ) : (
            image
          )}
        </div>
      );
    }
    return (
      <div className="hero__content-box">
        <HeroTitle colorTitle={colorTitle}>{title}</HeroTitle>
        {subtitle && (
          <HeroSubTitle colorSubtitle={colorSubtitle}>{subtitle}</HeroSubTitle>
        )}
        {callToActionText ? (
          <p className="hero__call-to-action">
            <CallToAction
              href={callToActionPath}
              text={trans(callToActionText)}
            />
          </p>
        ) : null}
      </div>
    );
  };

  return (
    <header className={heroClassname} style={inlineStyle}>
      <div className="hero__menu-wrapper">{menu}</div>
      <div className={`hero__wrapper ${className}`}>
        {children || renderContentBox()}
      </div>
    </header>
  );
};

HeroTitleWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

HeroTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  colorTitle: PropTypes.string
};

HeroSubTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  colorSubtitle: PropTypes.string
};

Hero.TitleWrapper = HeroTitleWrapper;
Hero.Title = HeroTitle;
Hero.SubTitle = HeroSubTitle;

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  backgroundImage: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small', 'big']),
  colorTitle: PropTypes.string,
  colorSubtitle: PropTypes.string,
  opacity: PropTypes.bool,
  callToActionPath: PropTypes.string,
  callToActionText: PropTypes.string,
  className: PropTypes.string,
  classNameImage: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  menu: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isRowAlignContent: PropTypes.bool,
  dataTest: PropTypes.string
};

export default Hero;
